import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable, Subject, Subscription } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  startWith,
  take,
  takeUntil,
} from 'rxjs/operators';
import { DietPlanData } from '../diet-plan.data';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatSelect } from '@angular/material/select';
import { NotificationComponent } from 'src/app/shared/components/notification/notification.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { PdfGeneratorService } from 'src/app/shared/services/pdf-generator.service';
import { UserDataService } from 'src/app/shared/services/user-data.service';

@Component({
  selector: 'app-diet-plan',
  templateUrl: './diet-plan.component.html',
  styleUrls: ['./diet-plan.component.scss'],
})
export class DietPlanComponent implements OnInit {
  @ViewChild('mySelect') mySelect!: MatSelect;
  hide = false;
  @Input() bmi: number | undefined;
  mealPlanForm: FormGroup = this.fb.group({
    mealPlans: this.fb.array([]),
    dietDo: [],
    dietDont: [],
    lifestyleDo: [],
    lifestyleDont: [],
    investigationAdvised: [],
    suppementAdvised: [],
    nextCounsellingDate: [new Date('DD/MM/YYYY')],
    nextCounsellingDesc: [],
    medicalHistory: [],
    diagnosis: [],
    dieteryPrinciples: [],
    medicalNotes: this.fb.array([]),
  });
  date = new Date();
  // nextCounsellingDate = this.date.setDate(this.date)
  searchInput = '';
  submitIcon = '../../../../assets/images/submit (5).png';
  personal = '../../../../assets/images/user (1).png';
  saveIcon = '../../../../assets/images/bookmark.png';
  eyeIcon = '../../../../assets/images/eye.png';
  downloadIcon = '../../../../assets/images/download.png';
  printIcon = '../../../../assets/images/printer (2).png';
  units = DietPlanData.UNITS;
  foodItems: any[] = [];
  choices = DietPlanData.CHOICES;
  filteredItems: any = [];
  @Input() clientProfile: any | undefined;
  sub!: Subscription;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  mealPlanContrl = new FormControl('');
  filteredeMealOpt: Observable<any>;
  mealPlanOptions = DietPlanData.MEAL_PLAN_OPTIONS;
  selectedMealOpt: any[] = [];
  private destroy$ = new Subject<void>();
  @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;
  subscription!: Subscription;
  dieteryPrinciples: any[] = [];
  investigationData: any[] = [];
  supplementData: any[] = [];
  dosDietData: any[] = [];
  dontDietData: any[] = [];
  dosLifestyleData: any[] = [];
  dontLifestyleData: any[] = [];
  isLoading = false;
  userUID: any;
  message = 'Loading data, please wait...';
  isSubmitted = false;
  pdfContent: any;
  constructor(
    private fb: FormBuilder,
    private firestore: AngularFirestore,
    private cd: ChangeDetectorRef,
    private snackbar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    public pdfGenerator: PdfGeneratorService,
    public userDataService: UserDataService
  ) {
    this.filteredeMealOpt = this.mealPlanContrl.valueChanges.pipe(
      startWith(null),
      map((mealOpt: any) =>
        mealOpt ? this._filter(mealOpt) : this.mealPlanOptions.slice()
      )
    );
    this.userUID = this.route.snapshot.params['id'];
  }

  ngOnInit(): void {
    if (this.userUID) {
      this.pdfGenerator.getData(this.userUID).then((data: any) => {
        this.pdfContent = data;
      });
      setTimeout(() => {
        this.getDietPlanData();
      }, 100);
    } else {
      this.addNotes();
    }

    this.userDataService.getData().subscribe({
      next: (data) => {
        if (data) {
          this.mealPlanForm.get('medicalHistory')?.setValue(data);
        }
      },
    });
    this.getAllSelectOptions();
  }

  getDietPlanData() {
    this.isLoading = true;
    this.firestore
      .collection('mealPlanForm')
      .doc(this.userUID)
      .get()
      .subscribe((data: any) => {
        if (data.data()) {
          const mealPlans = data.data().mealPlans;
          mealPlans.forEach((x: any, i: number) => {
            (this.mealPlanForm.get('mealPlans') as FormArray).push(
              this.getMealForm(x.label, false, false, x.mealPlanTime)
            );
            const mealPlanTimeCntrl = this.mealPlanForm.get([
              'mealPlans',
              i,
              'mealPlanTime',
            ]) as FormArray;
            x.mealPlanTime.forEach((y: any, j: number) => {
              (
                this.mealPlanForm.get([
                  'mealPlans',
                  i,
                  'mealPlanTime',
                ]) as FormArray
              ).push(this.getMealControls(true));
            });
          });
          const notes = data.data().medicalNotes;
          notes.forEach((note: any) => {
            (this.mealPlanForm.get('medicalNotes') as FormArray).push(
              this.getMedicalCntrl()
            );
          });

          setTimeout(() => {
            this.mealPlanForm.patchValue(data.data());
            this.initializeChildCtrl();
            this.transformDate();
            this.isLoading = false;
          }, 100);
        } else {
          this.isLoading = false;
        }
      });
  }

  initializeChildCtrl() {
    this.mealPlans.controls.forEach((x: any, i: number) => {
      // x.mealPlanTime.forEach((y: any, j: number) => {
      //   this.childSubscription(x.mealPlanTime, i, j);
      // });
      const mealPlanTime = x.get('mealPlanTime') as FormArray;
      mealPlanTime.controls.forEach((y: any, j: number) => {
        this.childSubscription(mealPlanTime, i, j);
      });
    });
  }

  transformDate() {
    this.medicalNotes.controls.forEach((x: any) => {
      x.controls['notesDate'].setValue(x.controls['notesDate'].value.toDate());
    });
    this.mealPlanForm.controls['nextCounsellingDate'].setValue(
      this.mealPlanForm.controls['nextCounsellingDate']?.value?.toDate()
    );
  }

  getAllSelectOptions() {
    this.getFoodItemsData();
    this.getDieteryPrinciples();
    this.getInvestigationData();
    this.getSupplementData();
    this.getSDosDietData();
    this.getDontDietData();
    this.getDosLifestyleData();
    this.getDontLifestyleData();
  }

  getFoodItemsData() {
    this.firestore
      .collection('foodForm')
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        data.forEach((e) => {
          const obj: any = e.payload.doc.data();
          this.foodItems.push(obj);
        });
        this.filteredItems = this.foodItems;
      });
  }

  getDieteryPrinciples() {
    this.firestore
      .collection('dieteryForm')
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        data.forEach((e) => {
          const obj: any = e.payload.doc.data();
          this.dieteryPrinciples.push(obj);
        });
        this.mealPlanForm
          .get('dieteryPrinciples')
          ?.setValue(this.dieteryPrinciples.map((x) => x.dietery));
      });
  }

  getInvestigationData() {
    this.firestore
      .collection('investigationForm')
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        data.forEach((e) => {
          const obj: any = e.payload.doc.data();
          this.investigationData.push(obj);
        });
        this.mealPlanForm
          .get('investigationAdvised')
          ?.setValue(this.investigationData.map((x) => x.investigation));
      });
  }

  getSupplementData() {
    this.firestore
      .collection('supplementsForm')
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        data.forEach((e) => {
          const obj: any = e.payload.doc.data();
          this.supplementData.push(obj);
        });
        this.mealPlanForm
          .get('suppementAdvised')
          ?.setValue(this.supplementData.map((x) => x.supplements));
      });
  }

  getSDosDietData() {
    this.firestore
      .collection('dosDietForm')
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        data.forEach((e) => {
          const obj: any = e.payload.doc.data();
          this.dosDietData.push(obj);
        });
        this.mealPlanForm
          .get('dietDo')
          ?.setValue(this.dosDietData.map((x) => x.dosDiet));
      });
  }

  getDontDietData() {
    this.firestore
      .collection('dontDietForm')
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        data.forEach((e) => {
          const obj: any = e.payload.doc.data();
          this.dontDietData.push(obj);
        });
        this.mealPlanForm
          .get('dietDont')
          ?.setValue(this.dontDietData.map((x) => x.dontDiet));
      });
  }

  getDosLifestyleData() {
    this.firestore
      .collection('dosLifestyleForm')
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        data.forEach((e) => {
          const obj: any = e.payload.doc.data();
          this.dosLifestyleData.push(obj);
        });
        this.mealPlanForm
          .get('lifestyleDo')
          ?.setValue(this.dosLifestyleData.map((x) => x.dosLifestyle));
      });
  }

  getDontLifestyleData() {
    this.firestore
      .collection('dontLifestyleForm')
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        data.forEach((e) => {
          const obj: any = e.payload.doc.data();
          this.dontLifestyleData.push(obj);
        });
        this.mealPlanForm
          .get('lifestyleDont')
          ?.setValue(this.dontLifestyleData.map((x) => x.dontLifestyle));
      });
  }

  getMedicalCntrl() {
    return this.fb.group({
      notesDate: [new Date()],
      medicalCondition: [],
    });
  }

  add(event: MatChipInputEvent): void {
    const value: any = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.selectedMealOpt.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.mealPlanContrl.setValue(null);
  }

  remove(mealOpt: any): void {
    const index = this.selectedMealOpt.indexOf(mealOpt);

    if (index >= 0) {
      this.selectedMealOpt.splice(index, 1);
      this.removeBreakFastForm(index, 0);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedMealOpt.push(event.option.value);
    this.fruitInput.nativeElement.value = '';
    this.mealPlanContrl.setValue(null);
    this.addMealPlan(false, 0, event.option.viewValue);
  }

  private _filter(value: string): any {
    if (typeof value === 'object') return;
    const filterValue = value.toLowerCase();

    return this.mealPlanOptions.filter((mealOpt) =>
      mealOpt.value.toLowerCase().includes(filterValue)
    );
  }

  get mealPlans(): FormArray {
    return this.mealPlanForm.get('mealPlans') as FormArray;
  }

  get medicalNotes(): FormArray {
    return this.mealPlanForm.get('medicalNotes') as FormArray;
  }

  isFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  isFormArray(control: any): FormArray {
    return control as FormArray;
  }

  getMealForm(
    label: string,
    child: boolean,
    isLabelChange: boolean,
    mealPlanTime?: any
  ): FormGroup {
    if (mealPlanTime) {
      return this.fb.group({
        isLabelUpdated: [isLabelChange],
        mealPlanLabel: [label],
        mealPlanTime: this.fb.array([]),
      });
    } else {
      return this.fb.group({
        isLabelUpdated: [isLabelChange],
        mealPlanLabel: [label],
        mealPlanTime: this.fb.array([this.getMealControls(child)]),
      });
    }
  }

  getMealControls(child: boolean): FormGroup {
    return this.fb.group({
      timing: [],
      foodItems: [],
      recipe: [],
      quantity: [],
      unit: [],
      choice: [],
      child: child,
    });
  }

  onFoodItemChange(e: any, mealPlanIndex: number, mealCtrlIndex: number) {
    const recipe = this.foodItems.filter((food) => food.foodItem === e)[0]
      .foodRecipe;
    const mealPlanTime = this.mealPlanForm.get([
      'mealPlans',
      mealPlanIndex,
      'mealPlanTime',
    ]) as FormArray;
    (mealPlanTime.controls[mealCtrlIndex].get('recipe') as FormGroup).setValue(
      recipe
    );
  }

  addMealPlan(child: boolean, index: number, label?: string): void {
    const mealPlans = this.mealPlanForm.get('mealPlans') as FormArray;
    index = mealPlans.length;
    let labelChange = false;
    if (label === 'Other Timing') {
      labelChange = true;
    }
    mealPlans.insert(index!, this.getMealForm(label!, child, labelChange));
    this.subscribeToValueChanges(mealPlans, index);
  }

  addMealControl(
    mealPlanIndex: number,
    mealControlIndex: number | undefined,
    child: boolean
  ): void {
    const mealPlanTime = this.mealPlanForm.get([
      'mealPlans',
      mealPlanIndex,
      'mealPlanTime',
    ]) as FormArray;
    if (mealControlIndex === undefined) {
      mealControlIndex = mealPlanTime.length;
    }
    mealPlanTime.insert(mealControlIndex!, this.getMealControls(child));
    setTimeout(() => {
      this.childSubscription(mealPlanTime, mealPlanIndex, mealControlIndex!);
    }, 50);
  }

  childSubscription(
    mealPlanTime: FormArray,
    mealPlanIndex: number,
    mealControlIndex: number
  ) {
    (
      mealPlanTime.controls[mealControlIndex].get('choice') as FormGroup
    ).valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value) => {
        if (value !== null) {
          this.addMealControl(mealPlanIndex, mealControlIndex + 1, true);
        }
      });
  }

  subscribeToValueChanges(mealPlan: FormArray, index: number) {
    const mealPlanTime = mealPlan.controls[index].get(
      'mealPlanTime'
    ) as FormArray;
    mealPlanTime.controls.forEach((mealControl, mealControlIndex) => {
      this.subscription = mealControl.valueChanges
        .pipe(distinctUntilChanged())
        .subscribe((value) => {
          if (
            value.choice !== null &&
            (mealPlanTime.length < 2 || value.child === true)
          )
            this.addMealControl(index, mealControlIndex + 1, true); // call addMealPlan() method
        });
    });
  }

  removeBreakFastForm(mealPlanIndex: number, mealCtrlIndex: number) {
    if (mealCtrlIndex === 0) {
      const mealPlan = this.mealPlanForm.get(['mealPlans']) as FormArray;
      mealPlan.removeAt(mealPlanIndex);
      this.selectedMealOpt.splice(mealPlanIndex, 1);
    } else {
      const mealPlanTime = this.mealPlanForm.get([
        'mealPlans',
        mealPlanIndex,
        'mealPlanTime',
      ]) as FormArray;
      mealPlanTime.removeAt(mealCtrlIndex);
    }
  }

  selectTime(e: any, mealPlanIndex: number, mealCtrlIndex: number) {
    const mealPlanTime = this.mealPlanForm.get([
      'mealPlans',
      mealPlanIndex,
      'mealPlanTime',
    ]) as FormArray;
    (mealPlanTime.controls[mealCtrlIndex].get('timing') as FormGroup).setValue(
      e
    );
  }

  onSubmit(label: string) {
    this.isLoading = true;
    if (label === 'Submitted') {
      this.message = 'Submit diet plan, please wait...';
    } else {
      this.message = 'Saving diet plan, please wait...';
    }

    this.firestore
      .collection('mealPlanForm')
      .doc(this.clientProfile.userUID)
      .set(this.mealPlanForm.getRawValue())
      .then((data) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: `Diet Plan ${label} Successfully.`,
            type: 'success',
          },
        });
        this.isLoading = false;
        this.updateClientStatus();
        this.updateAppointmentStatus();
        if (label === 'Submitted') {
          this.isSubmitted = true;
          this.pdfGenerator.viewPdf(this.pdfContent);
          this.router.navigate(['./layout/create-diet-plan/']);
        }
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
        this.isLoading = false;
      });
  }

  updateClientStatus() {
    const document = this.firestore
      .collection('clientProfile')
      .doc(this.clientProfile.userUID);
    const data = document.update({ status: 'Active' }).then(() => {
      console.log('Client status updated successfully');
    });
  }

  updateAppointmentStatus() {
    this.firestore
      .collection('appointmentDetails')
      .doc(this.clientProfile.userUID)
      .get()
      .subscribe((data: any) => {
        if (data.data()) {
          const aptData = data.data();
          aptData.appointDetails.forEach((apt: any) => {
            if (apt.appotStatus === 'Scheduled') {
              apt.appotStatus = 'Completed';
            }
          });
          this.firestore
            .collection('appointmentDetails')
            .doc(this.clientProfile.userUID)
            .set(aptData)
            .then((data) =>
              console.log('Appopintment status updated successfully')
            );
        }
      });
  }

  onSearch(e: any) {
    const val = e?.target?.value;
    setTimeout(() => {
      this.filteredItems = this.foodItems.filter((item) =>
        item.foodItem.toLocaleLowerCase().includes(val.toLocaleLowerCase())
      );
    }, 50);
  }

  getFoodItems(mealPlanIndex: number, mealCtrlIndex: number) {
    const mealPlanTime = this.mealPlanForm.get([
      'mealPlans',
      mealPlanIndex,
      'mealPlanTime',
    ]) as FormArray;
    const value = (
      mealPlanTime.controls[mealCtrlIndex].get('foodItems') as FormGroup
    ).value;
    let filteredItems;
    setTimeout(() => {
      this.filteredItems = this.foodItems.filter((item) =>
        item.toLocaleLowerCase().includes(value?.toLocaleLowerCase())
      );
    }, 50);
    return value === null || value === '' ? this.foodItems : this.filteredItems;
  }

  onBlur() {
    this.filteredItems = this.foodItems;
  }

  addNotes() {
    const medicalNotes = this.mealPlanForm.get('medicalNotes') as FormArray;
    medicalNotes.controls.push(this.getMedicalCntrl());
  }

  removeNotes(index: number) {
    const medicalNotes = this.mealPlanForm.get('medicalNotes') as FormArray;
    medicalNotes.removeAt(index);
  }
}
